import _indexOfInstanceProperty from "../../core-js/instance/index-of";
export default function _isNativeFunction(fn) {
  var _context;

  return _indexOfInstanceProperty(_context = Function.toString.call(fn)).call(_context, "[native code]") !== -1;
}


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/node_modules/@babel/runtime-corejs3/helpers/esm/isNativeFunction.js
// module id = 2870
// module chunks = 1